













































































































































































































































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import { errorToMessage } from '@/core/utils/errors';
import * as EventUtils from '@/core/utils/events';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import ActivityItem from '@/web/components/dashboard/ActivityItem.vue';
import CreateProductModal from '@/web/components/products/CreateProductModal.vue';
import MediaFormModal from '@/web/components/media-library/MediaFormModal.vue';
import CommunityNotifications from '@/web/components/community/CommunityNotifications.vue';
import { mixin as clickaway } from 'vue-clickaway';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';
import TeacherPermissionsMixin from '@/web/mixins/TeacherPermissionsMixin';

export default Vue.extend({
  name: 'Dashboard',
  mixins: [clickaway, TeacherPermissionsMixin],
  components: {
    TopNav,
    NavItem,
    ActivityItem,
    CommunityNotifications,
  },
  data() {
    return {
      isLoading: true,
      showNotifications: false,
      displayLarge: true,
    };
  },
  computed: {
    ...mapGetters({
      teacher: 'user/teacher',
      studentMagicCode: 'user/studentMagicCode',
      teacherStudioUrl: 'user/teacherStudioUrl',
      numberOfStudioNotifications: 'community/numberOfStudioNotifications',
      numberOfChatNotifications: 'community/numberOfChatNotifications',
      studioURL: 'user/studioURL',
    }),
    dashboardStats() {
      return this.$store.state.dashboard.dashboard;
    },
  },
  methods: {
    getStudentViewURL(studioUrl, path = '/') {
      return getStudentViewURL(studioUrl, path, this.teacherMagicCode);
    },
    openUploadFilesModal() {
      this.$modal.show(
        MediaFormModal,
        {
          videoUploadAllowed: this.videoUploadAllowed,
        },
        {
          clickToClose: false,
        }
      );
    },
    openAddProductModal() {
      this.$modal.show(CreateProductModal);
    },
    shortTime(datetime) {
      return EventUtils.shortTime(datetime);
    },
    onNotificationsIconClick() {
      this.showNotifications = !this.showNotifications;
    },
    onScroll() {
      this.displayLarge = window.scrollY < 10;
    },
    hideNotifications() {
      this.showNotifications = false;
    },
    getNotificationsStyle() {
      const notificationsTrigger = this.$refs.notificationsTrigger;
      if (!notificationsTrigger) return {};
      const boundingRect = notificationsTrigger.getBoundingClientRect();
      if (boundingRect.left - 380 > 0) {
        return {
          left: `${Math.max(boundingRect.left - 380, 0)}px`,
        };
      } else {
        return {
          right: `1px`,
        };
      }
    },
  },
  async mounted() {
    document.addEventListener('scroll', this.onScroll);
    this.onScroll();
    try {
      await this.$store.dispatch('dashboard/getDashboardData');
    } catch (error) {
      this.$notify({
        group: 'app',
        type: 'error',
        title: this.$t('DASHBOARD.NOTIFICATIONS.FETCH_DASHBOARD_DATA_ERROR'),
        text: errorToMessage(error?.response, `Request failed: ${error}`),
        duration: -1, // stay ON
      });
    } finally {
      this.isLoading = false;
    }
    setTimeout(() => {
      try {
        if (window?.Beamer?.notificationNumber > 0) window.Beamer.show();
      } catch (_) {
        // do nothing
      }
    }, 1000);
  },
  destroyed() {
    document.removeEventListener('scroll', this.onScroll);
  },
  watch: {
    $route({ name }) {
      this.showNotifications = false;
    },
  },
});
